<h1 mat-dialog-title>Solicitud documentos CCR</h1>
<div mat-dialog-content>
    <div style="overflow-y:scroll;height:300px !important;padding-bottom: 200px;">
        <div *ngFor="let item of data.datospreca; let i = index">
            <div class="item-ccr">
                <div class="row">
                    <div class="col-md-11">
                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-5">
                                <h3>Nombre entidad</h3>
                                <h2>{{item.nomEntidad}}</h2>
                            </div>
                            <div class="col-md-3">
                                <h3>Capital Original</h3>
                                <h2>{{item.capitalOriginal| currency:"Q "}}</h2>
                            </div>
                            <div class="col-md-4">
                                <h3>Tipo de comprobante</h3>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="containercheck">
                                            <h2>Finiquito</h2>
                                            <input *ngIf="listindexfiniquito.includes(item.correlativo)" type="checkbox" (change)="changeindextype(item.correlativo,1)" id="1" checked>
                                            <input *ngIf="!listindexfiniquito.includes(item.correlativo)" type="checkbox" (change)="changeindextype(item.correlativo,1)" id="1" >
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="containercheck">
                                            <h2>Cancelación</h2>
                                            <input type="checkbox" *ngIf="listindexcancelacion.includes(item.correlativo)" (change)="changeindextype(item.correlativo,2)" id="1" checked>
                                            <input type="checkbox" *ngIf="!listindexcancelacion.includes(item.correlativo)" (change)="changeindextype(item.correlativo,2)" id="1">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="listindexactive.includes(i)">
                            <div class="col-md-3">
                                <h3>Monto saldo capital</h3>
                                <h2>{{item.montoSaldoCapital| currency:"Q "}}</h2>
                            </div>
                            <div class="col-md-3">
                                <h3>Fecha cancelación</h3>
                                <h2>{{this.setFormatDate(item.fechaCancelacion)}}</h2>
                            </div>
                            <div class="col-md-3">
                                <h3>Fecha saldo capital</h3>
                                <h2>{{this.setFormatDate(item.fechaSaldoCapital)}}</h2>
                            </div>
                            <div class="col-md-3">
                                <h3>Persona</h3>
                                <h2>{{item.persona}}</h2>
                            </div>
                            <div class="col-md-8">
                                <h3>Forma de cancelación</h3>
                                <h2>{{item.formaCancelacion}}</h2>
                            </div>
                            <div class="col-md-4">
                                <h3>Codigo forma cancelación</h3>
                                <h2>{{item.codigoFormaCancelacion}}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <button *ngIf="listindexactive.includes(i)" style="margin:0;border:0;background-color: #fff;">
                            <span (click)="changeindexactive(i)" class="icon icon-up"
                            style="width: 22.5px;height: 17px;"></span>
                        </button>
                        <button *ngIf="!listindexactive.includes(i)" style="margin:0;border:0;background-color: #fff;">
                            <span (click)="changeindexactive(i)" class="icon icon-down"
                            style="width: 22.5px;height: 17px;"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 30px;margin-bottom: 20px;">
        <div class="col-md-1">

        </div>
        <div class="col-md-10">
            <h3>Observaciones:</h3>
            <textarea [(ngModel)]="descripcion" class="form-control" id="exampleFormControlTextarea1" rows="3" maxlength="500"></textarea>
        </div>
        <div class="col-md-1">

        </div>
        <div class="col-md-6">
            <div style="text-align: right">
                <button class="btn round-button" style="color:#ac1949;" (click)="onNoClick()">Cancelar</button>
            </div>
        </div>
        <div class="col-md-6">
            <div style="text-align: left;">
                <button class="btn round-button" (click)="changeSatus('aprobar')">Aprobar</button>
            </div>
        </div>
    </div>
</div>